// Palette
import palette from "../palette";

export default {
  root: {
    borderCollapse: "separate",
    padding: 10
  }
};
